import { gql } from '@apollo/client';

export const GET_IS_GRACE_PERIOD = gql`
  query wIsSubscriptionInGracePeriod($uid: UUID!) {
    wIsSubscriptionInGracePeriod(uid: $uid)
  }
`;
